export const translateIDForDocs = (componentSummaryId: string) => {
  // Translations weren't used here because the componentSummaryId is used in the URL for the component docs, we would need to check with the docs team if they are planning on internationizing slugs for the docs
  switch (componentSummaryId) {
    case 'create-external-table-sf':
      return 'create-external-table'
    case 'extract-nested-data-sf':
      return 'extract-nested-data'
    case 'data-transfer-object':
      return 'data-transfer'
    case 'microsoft-sql-server-output':
      return 'sql-server-output'

    default:
      return componentSummaryId
  }
}
